import {useCallback, useRef, useState} from 'react';
import {Container, Modal, Spinner} from 'react-bootstrap';
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {certificationApi} from '../../../config/firebase';
import {getDownloadURL, ref} from "firebase/storage";
import QuickPinchZoom, {make3dTransformValue} from "react-quick-pinch-zoom";
import {toast} from "react-toastify";
import "./search-form.scss";
import { storage } from '../../../config/firebase';

function CertificationSearchForm() {
  const [validated, setValidated] = useState(false);
  const [certKeyError, setCertKeyError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState('');
  const [showModal, setShowModal] = useState(false);

  const formRef = useRef(null);
  const imgRef = useRef(null);
  const certKeyInputRef = useRef(null);

  const onUpdate = useCallback(({ x, y, scale }) => {
    if (imgRef.current) {
      const value = make3dTransformValue({ x, y, scale });
      imgRef.current.style.setProperty("transform", value);
    }
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    
    if (!certKeyInputRef.current) return;
    
    const certKeyValue = certKeyInputRef.current.value;
    const isValid = certKeyInputRef.current.checkValidity();
    
    if (!isValid) {
      setValidated(true);
      if (!certKeyValue) {
        setCertKeyError('Campo obrigatório.');
      }
      if (certKeyValue.length !== 32) {
        setCertKeyError('A chave deve conter 32 caracteres.');
      }
    } else {
      fetchCertificationById(certKeyValue);
    }
  };

  async function fetchCertificationById(certificationId) {
    setIsLoading(true);
    try {
      await certificationApi.getById({ certificationId });
      const imageRef = ref(storage, `certifications/${certificationId}.jpg`);
      const url = await getDownloadURL(imageRef);
      setImageUrl(url);
      setShowModal(true);
    } catch (error) {
      toast.error('Certificado não encontrado.', { position: 'bottom-center' });
    } finally {
      setIsLoading(false);
      setValidated(false);
    }
  }

  return (
    <Container className="search-form">
      <Form noValidate validated={validated} ref={formRef} onSubmit={handleSubmit}>
        <Row className="mb-3">
          <Form.Group as={Col} md="12" controlId="certKey" className="form-group">
            <h6 htmlFor="certKey">Consultar Certificado</h6>
            <Form.Control
              ref={certKeyInputRef}
              required
              name="certKey"
              type="text"
              minLength={32}
              maxLength={32}
              placeholder="Código do Certificado (certification code)"
            />
            <Form.Control.Feedback type="invalid">
              {certKeyError}
            </Form.Control.Feedback>
          </Form.Group>
        </Row>
        <button type="submit" className="btn-custom float-end" disabled={isLoading}>
          Consultar
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
            className="ms-2"
            hidden={!isLoading}
          />
        </button>
      </Form>
      <Modal id="preview-modal" show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <h4>Visualização Certificado</h4>
        </Modal.Header>
        <Modal.Body>
          <QuickPinchZoom onUpdate={onUpdate}>
            <img ref={imgRef} className="certification-preview-img" src={imageUrl} alt="Preview" />
          </QuickPinchZoom>
        </Modal.Body>
      </Modal>
    </Container>
  );
}

export default CertificationSearchForm;
